import {
  compose,
  pure
} from 'recompose'
import Moment from 'react-moment'

import {
  Pagination,
  Loader
} from '../../uiLib'
import { withI18next } from '../../../lib/withI18next'

const LoginHistory = props => {
  return (
    <div className="login-history column is-8 m-b-md p-b-md" name="login-history">
      {
        !!props.list.length &&
        <div>
          <table className="table is-bordered login-history-list">
            <thead>
              <tr>
                <th>{props.t('login-time')}</th>
                <th>{props.t('ip-address')}</th>
              </tr>
            </thead>
            <tbody>
              {
                props.loading &&
                <tr className="login-history-list has-text-centered">
                  <td colSpan="2">
                    <Loader />
                  </td>
                </tr>
              }
              {
                !!props.list.length && props.list.map(item => (
                  <tr className="login-history-list" key={item.id}>
                    <td>
                      <Moment format="MM/DD/YYYY hh:mm:ss A">{item.occured}</Moment>
                    </td>
                    <td>{item.ip_address}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      }

      {
        !props.list.length &&
        <div>{props.t('common:no-login-history')}</div>
      }
      <Pagination
        className="m-t-md"
        pageCount={props.pageCount}
        onPageChange={selected => props.handlePageClick(selected, props.userId)}
        initialPage={props.initialPage}
        isSmall
      />
    </div>
  )
}

LoginHistory.defaultProps = {
  list: []
}

export default compose(
  withI18next('common'),
  pure
)(LoginHistory)



// WEBPACK FOOTER //
// ./components/Common/UserDetails/LoginHistory.js